import { useQuery } from '@tanstack/react-query'

import { api } from '@/api/client'

export type TenantLocale = {
  code: string
  name: string
  native_name: string
  direction: string
  flag_emoji?: string | null
  is_default?: boolean
}

const FALLBACK: TenantLocale[] = [
  { code: 'tr', name: 'Turkish', native_name: 'Türkçe', direction: 'ltr', flag_emoji: '🇹🇷', is_default: true },
  { code: 'en', name: 'English', native_name: 'English', direction: 'ltr', flag_emoji: '🇬🇧' },
]

export function useLocales() {
  return useQuery({
    queryKey: ['tenant-locales'],
    queryFn: async (): Promise<TenantLocale[]> => {
      const { data } = await api.get('/config')
      const locales = data.data?.locales
      return Array.isArray(locales) && locales.length > 0 ? locales : FALLBACK
    },
    staleTime: 5 * 60 * 1000,
  })
}

export function localeCodes(locales: TenantLocale[]): string[] {
  return locales.map((l) => l.code)
}
